import React from 'react';

import { Container, Typography } from '@mui/material';

import PageHeader from '~/components/Common/Elements/PageHeader';

import useCanAccessLeLens from '~/hooks/useCanAccessLeLens';
import { SurfacePlate } from '~/pages/LeLens/surface';

type LensAccessGateProps = { children: React.ReactNode };

export default function LensAccessGate({ children }: LensAccessGateProps) {
  const canAccess = useCanAccessLeLens();

  if (!canAccess) {
    return (
      <Container>
        <PageHeader title="askRichard" />
        <SurfacePlate padding="plate">
          <Typography sx={{ fontWeight: 700 }} variant="subtitle1">
            askRichard is in a closed pilot.
          </Typography>
          <Typography color="text.secondary" sx={{ mt: 1 }} variant="body2">
            Today it&apos;s open to reporting admins and a small pilot list. To be added, email{' '}
            <a href="mailto:data@luxuryescapes.com">data@luxuryescapes.com</a> and say what you&apos;d use it for.
          </Typography>
        </SurfacePlate>
      </Container>
    );
  }

  return <>{children}</>;
}
